<script setup lang="ts">
const props = defineProps({
  username: {
    type: String,
    required: true,
  },
  image: {
    type: String,
  },
  imageClass: {
    type: String,
    default:
      "bg-blue-100 w-10 h-10 flex justify-center items-center rounded-md",
  },
  textClass: {
    type: String,
    default: "bg-blue-100 w-10 h-10 flex justify-center items-center rounded-md text-blue-500 text-md",
  },
});

const isImageLoaded = ref(false)

const handleLoad = () => {
  isImageLoaded.value = true
}

const Initials: any = () => {
  const name = props.username.split(" ");
  return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ""}`;
};
</script>

<template>
  <div :class="['relative overflow-hidden', imageClass]">
    <!-- Loader shown while the image is loading -->
     <div class="h-full w-full" v-if="image">
       <div
         v-if="!isImageLoaded"
         class="absolute inset-0 flex items-center justify-center bg-gray-100 z-10 w-full h-full"
       >  
          <Loader className="w-4 h-4" />
       </div>
   
       <img
         :src="image"
         alt="Image preview"
         class="object-cover w-full h-full"
         @load="handleLoad"
       />
     </div>

    <span :class="textClass" v-else>{{ Initials() }}</span>
  </div>
</template>